import {
  ALL,
  SENIORITY_MISSING_DATA,
  SENIORITY_CRITICAL_MISSING_DATA,
  ALL_ISSUES,
  CRITICAL_ISSUES,
  NON_CRITICAL_ISSUES,
} from "./constants";

export const filterSeniorityList = (seniorityList, filterSetting) => {
  let filteredSeniorityList = seniorityList.filter((employee) => {
    let isEmployeeInNewFilteredList = filterSetting === ALL || employee.ftpt === filterSetting;
    return isEmployeeInNewFilteredList;
  });
  return filteredSeniorityList;
};

export function sortSeniorityList(typeOfA, typeOfB, valueA, valueB) {
  const _a = valueA.api.getCellValue(valueA.id, valueA.field);
  const _b = valueB.api.getCellValue(valueB.id, valueB.field);
  const a = parseInt(_a, 10);
  const b = parseInt(_b, 10);
  const sortOrder = valueA.api.getSortModel()[0]["sort"];

  // check if either a or b is not a number (contains '-')
  const isANumber = !isNaN(typeOfA);
  const isBNumber = !isNaN(typeOfB);

  if (!isANumber && !isBNumber) {
    return 0; // Both are NaN, consider them equal
  }
  if (a === b) {
    return 0;
  }

  if (sortOrder === "asc") {
    if (isNaN(typeOfA)) {
      // prioritize if NaN
      return -1;
    }
    if (isNaN(typeOfB)) {
      return 1;
    }
    return a > b ? 1 : -1; // compare if numbers
  }

  if (sortOrder === "desc") {
    if (isNaN(typeOfA)) {
      // prioritize if NaN
      return 1;
    }
    if (isNaN(typeOfB)) {
      return -1;
    }
    return a < b ? -1 : 1; // compare if numbers
  }
}
export const filterAllIssuesSeniorityList = (seniorityList, issueType) => {
  let filteredSeniorityList = [];
  if (issueType === ALL_ISSUES) {
    // filtering both critical and non-critical issues and sorting from critical to non-critical
    filteredSeniorityList = seniorityList
      .filter(
        (employee) =>
          Object.values(employee).includes(SENIORITY_CRITICAL_MISSING_DATA) ||
          Object.values(employee).includes(SENIORITY_MISSING_DATA)
      )
      .sort((a, b) => {
        const aValue = Object.values(a).includes(SENIORITY_CRITICAL_MISSING_DATA);
        const bValue = Object.values(b).includes(SENIORITY_CRITICAL_MISSING_DATA);
        return bValue - aValue;
      });
  }

  if (issueType === CRITICAL_ISSUES) {
    filteredSeniorityList = seniorityList.filter((employee) =>
      Object.values(employee).includes(SENIORITY_CRITICAL_MISSING_DATA)
    );
  }

  if (issueType === NON_CRITICAL_ISSUES) {
    filteredSeniorityList = seniorityList.filter((employee) =>
      Object.values(employee).includes(SENIORITY_MISSING_DATA)
    );
  }

  return filteredSeniorityList;
};
